import React from 'react';
import { DropdownEsito, RecursiveEsitoGrid, RecursiveEsitoList } from 'components/scommesseTipo/components/esito';
import { ScommesseDropdownRecursive, ScommesseDropdownRecursiveProps } from 'components/scommesseTipo/components/scommesseDropdownRecursive/ScommesseDropdownRecursive';
import { esito, esitoTrKey } from 'components/scommesseTipo';
import { useInfoAggiuntivaIndex, useInfoTipo } from 'features/sport/hooks';

import { ScommesseLeafItem } from 'components/scommesseTipo/components/cells';
import { VisualizationEnum } from 'lib/api/sport/sportScommesseBySlugResponse';
import { isTruthy } from 'utility/functions';

export const ScommesseDropdownRecursiveItem = (props: ScommesseDropdownRecursiveProps) => {
  const { counter, isEstesa, hasTitleHeader, infoAggiuntivaKey, infoTipoScommessaId, scommessaKey, gtagAction } = props;
  const infoTipoScommessa = useInfoTipo(infoTipoScommessaId);
  const infoAggIndex = useInfoAggiuntivaIndex(infoAggiuntivaKey);

  // console.log('ScommesseDropdownRecursiveItem', props)

  const renderContet = () => {
    const key = `ScommesseDropdownRecursiveItem-${infoAggiuntivaKey}`;
    const { nextInfoAgg } = infoAggIndex ?? {};

    if (isTruthy(nextInfoAgg?.length)) {
      return <ScommesseDropdownRecursive {...props} counter={counter + 1} />;
    }

    if (infoTipoScommessa.tipoVisualizzazione === VisualizationEnum.MultipleInfoAggEsitiUnderThree) {
      return (
        <RecursiveEsitoList
          key={key}
          scommessaKey={scommessaKey}
          hasTitleHeader={hasTitleHeader}
          infoAggiuntivaKey={infoAggiuntivaKey}
          infoTipoScommessaId={infoTipoScommessaId}
          gtagAction={gtagAction}
          // key={`recrusive_infoAgg_${selectedRecursiveInfoAgg?.valore}_${selectedRecursiveRow}`}
        />
      );
    }

    if (isEstesa) {
      return (
        <RecursiveEsitoGrid
          key={key}
          scommessaKey={scommessaKey}
          infoAggiuntivaKey={infoAggiuntivaKey}
          gtagAction={gtagAction}
        />
      );
    }

    const type = (infoTipoScommessa?.numeroEsiti ?? 0) < 4 ? ScommesseLeafItem.Esito : ScommesseLeafItem.Quota;
    return (
      <DropdownEsito
        key={key}
        counter={counter + 1}
        headerBox={'\u00a0'}
        type={type}
        scommessaKey={scommessaKey}
        headerSelect={hasTitleHeader ? esito : undefined}
        headerSelectTrKey={esitoTrKey}
        infoAggiuntivaKey={infoAggiuntivaKey}
        // internalDropdownHeaders={[esito]}
        // internalDropdownHeadersTrKey={[esitoTrKey]}
        gtagAction={gtagAction}
      />
    );
  };

  return renderContet();
};